import api from "./axios";
import type { CreatePaymentType } from "@/struct/PaymentStruct";

export default class CustomerService {
  changeMainCustomer = (newMainCustomerMsisdn: string) => {
    return api.post("/api/mobile/account/change-main-customer", {
      new_customer_msisdn: newMainCustomerMsisdn.toString(),
    });
  };

  getChildAccounts = () => {
    return api.get("/api/mobile/account/get-child-accounts");
  };

  createPayment = (payload: CreatePaymentType) => {
    return api.post("/api/web-api/web/create-payment", payload);
  };
}
